import { Component, OnDestroy, OnInit } from '@angular/core';
import { OrgTreeActionsDirective } from '../../directives/org-tree-actions.directive';
import { OrgTreeService } from '../../services/org-tree.service';
import { Subscription } from 'rxjs';
import { currentReportingPeriod, reportingPeriod } from '../../../../shared/helpers/helpers';
import { GuardService } from '../../../../shared/services/guard.service';
import { ReportService } from '../../../../shared/services/report.service';
import { SnackService } from '../../../../shared/services/snack.service';
import { IReportLight } from '../../../../shared/interfaces/reports/IReportLight';
import { groupBy } from 'lodash-es';
import { IReport } from '@shared/interfaces';
import { Router } from '@angular/router';
import { OrganisationService } from '../../../../shared/services/organisation.service';
import { ModuleService } from '../../../../shared/services/module.service';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../../current-project';

@Component({
    selector: 'app-org-drawer-reports',
    templateUrl: './org-drawer-reports.component.html',
    styleUrls: ['./org-drawer-reports.component.scss'],
    standalone: false
})
export class OrgDrawerReportsComponent extends OrgTreeActionsDirective implements OnInit, OnDestroy {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    subscriptions: Subscription[] = [];
    selectedReportingPeriod = currentReportingPeriod;
    groupedData: { [key: string]: IReportLight[] };
    selectedIndex = 0;
    isSaving: boolean;
    previousOrgCode: string;

    periods = [
        reportingPeriod(),
        reportingPeriod(1),
        reportingPeriod(2)
        // 'other'
    ];

    constructor(
        orgTreeService: OrgTreeService,
        private reportService: ReportService,
        private router: Router,
        private snack: SnackService,
        private organisationService: OrganisationService,
        private guardService: GuardService,
        moduleService: ModuleService
    ) {
        super(orgTreeService, moduleService);
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.orgTreeService.toggleDrawer.subscribe(e => {
                if (e?.isOpen) {
                    this.groupedData = this.previousOrgCode !== this.selectedItem?.orgCode ? null : this.groupedData;
                    this.selectedReportingPeriod = currentReportingPeriod;
                    this.loadData(e.force);
                }
            }),
            this.shouldReloadOrgTree.subscribe(
                (e: string[]) => this.selectedItem && e?.includes(this.selectedItem.orgCode) && this.loadData()
            )
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(e => e.unsubscribe());
    }

    async loadData(force?: boolean) {
        if (IS_TRS_PROJECT) {
            if (
                !force &&
                this.previousOrgCode === this.selectedItem?.orgCode &&
                this.groupedData &&
                this.groupedData[(this.periods[0] as { label: string; showLabel: string }).label]
            ) {
                return;
            }
        }

        if (IS_PRODUCT_SAFETY_PROJECT) {
            if (
                !force &&
                this.previousOrgCode === this.selectedItem?.orgCode &&
                this.groupedData &&
                this.groupedData[this.periods[0] as string]
            ) {
                return;
            }
        }

        const reports = await this.reportService.getItemsLight({
            orgCode: this.selectedItem?.orgCode,
            lastThreeReports: true
        });
        if (IS_TRS_PROJECT) {
            reports.forEach(e => {
                (e as IReport).responsible = this.selectedItem;
                e.groupedReportingPeriod = this.periods
                    .map(a => (a as { label: string; showLabel: string }).label)
                    .includes(e.reportingPeriod)
                    ? e.reportingPeriod
                    : 'other';
            });
        }
        if (IS_PRODUCT_SAFETY_PROJECT) {
            reports.forEach(e => {
                (e as IReport).responsible = this.selectedItem;
                e.groupedReportingPeriod = this.periods.includes(e.reportingPeriod) ? e.reportingPeriod : 'other';
            });
        }

        this.groupedData = groupBy(reports, (e: IReportLight) => e.groupedReportingPeriod);

        this.previousOrgCode = this.selectedItem?.orgCode;
    }

    setItem(item: IReport) {
        return this.router.navigateByUrl('report/' + encodeURIComponent(item.id));
    }

    reportingPeriod = (val?: number) => reportingPeriod(val);

    protected periodLabel(period: string | { label: string; showLabel: string }): { label: string; showLabel: string } {
        return period as { label: string; showLabel: string };
    }

    protected periodLabelString(period: string | { label: string; showLabel: string }): string {
        return period as string;
    }

    protected changeTab(value: string): void {
        this.selectedReportingPeriod = value;
    }
}
